import React from 'react';
import type { SvgProps } from 'react-native-svg';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export interface AppleIconProps extends SvgProps {
  size?: number;
  color: string; // Required - caller must pass semantic token color
}

export const AppleIcon: React.FC<AppleIconProps> = ({
  size = 14,
  color,
  ...props
}) => {
  const width = (size * 11) / 14; // Maintain aspect ratio 11:14
  return (
    <Svg width={width} height={size} viewBox="0 0 11 14" fill="none" {...props}>
      <G clipPath="url(#clip0_204_38225)">
        <Path
          d="M9.18735 7.43771C9.20633 9.55637 10.9805 10.2614 11.0002 10.2704C10.9852 10.3201 10.7167 11.2751 10.0654 12.2616C9.50245 13.1144 8.9182 13.9641 7.99779 13.9817C7.09339 13.999 6.80257 13.4259 5.76859 13.4259C4.73492 13.4259 4.41181 13.9641 3.5557 13.999C2.66727 14.0339 1.99071 13.0768 1.4231 12.2271C0.263196 10.4889 -0.623209 7.31549 0.56701 5.17337C1.15828 4.10959 2.21494 3.43596 3.36184 3.41868C4.23426 3.40143 5.05769 4.02704 5.59104 4.02704C6.12404 4.02704 7.12469 3.27469 8.17667 3.38518C8.61706 3.40418 9.85327 3.56957 10.647 4.7739C10.5831 4.815 9.17201 5.66644 9.18735 7.43771ZM7.48764 2.23526C7.95932 1.64347 8.27678 0.819645 8.19017 -5.34058e-05C7.51029 0.0282698 6.68816 0.469542 6.20049 1.06101C5.76345 1.58477 5.3807 2.42309 5.48398 3.22657C6.24179 3.28734 7.01594 2.82742 7.48764 2.23526Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_204_38225">
          <Rect width="11" height="14" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

AppleIcon.displayName = 'AppleIcon';
